import { testMode } from "../config";

//* Set Domain and ClientId for Auth0 at application start!
export const getDomainAndClientId = (configAgencyName: string): ObjectI => {
  let domain: string = "",
    clientId: string = "";

  if (process.env.NODE_ENV === "development" || testMode) {
    //* Development
    domain = process.env.REACT_APP_AUTH0_DOMAIN_Dev as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_Dev as string;
    //* Kombus Kórnik, Środa Wlkp, Kombus ZTM
  } else if (
    configAgencyName === ("kombusKornik" as string) ||
    configAgencyName === ("kombusSroda" as string) ||
    configAgencyName === ("kombusZTM" as string)
  ) {
    domain = process.env.REACT_APP_AUTH0_DOMAIN_Kombus as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_Kombus as string;
  } else if (
    //* Miami Springs, Miami-Beach, Sweet-Water, Doral, Fort-Lauderdale, Small-Cities, Pompano Beach
    configAgencyName === ("MiamiSprings" as string) ||
    configAgencyName === ("SmallCities" as string) ||
    configAgencyName === ("MiamiBeach" as string) ||
    configAgencyName === ("SweetWater" as string) ||
    configAgencyName === ("Doral" as string) ||
    configAgencyName === ("FortLauderdale" as string) ||
    configAgencyName === ("PompanoBeach" as string) ||
    configAgencyName === ("BCT" as string)
  ) {
    domain = process.env.REACT_APP_AUTH0_DOMAIN_TA_Rest as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_TA_Rest as string;
    //* Miami-Dade
  } else if (configAgencyName === ("MiamiDade" as string)) {
    domain = process.env.REACT_APP_AUTH0_DOMAIN_TA_MDT as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_TA_MDT as string;
    //* PKS
  } else if (configAgencyName === ("PoznanPKS" as string)) {
    domain = process.env.REACT_APP_AUTH0_DOMAIN_PKS as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_PKS as string;
    //* Rokbus
  } else if (configAgencyName === ("Rokbus" as string)) {
    domain = process.env.REACT_APP_AUTH0_DOMAIN_Kombus as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_Kombus as string;
    //* KiedyBusDyspozytor - TEST!
  } else if (configAgencyName === ("KiedyBusDyspozytor" as string)) {
    domain = process.env.REACT_APP_AUTH0_DOMAIN_KiedyBusDyspozytor as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_KiedyBusDyspozytor as string;
  } else {
    //* Default (Development)
    domain = process.env.REACT_APP_AUTH0_DOMAIN_Dev as string;
    clientId = process.env.REACT_APP_AUTH0_CLIENT_ID_Dev as string;
  }

  return { domain, clientId };
};
